import * as StreamrClientExports from './exports'

Object.assign(StreamrClientExports.StreamrClient, StreamrClientExports)

export default StreamrClientExports.StreamrClient
